import React, { useContext } from 'react';
import { Text, Typography } from '@fiverr-private/typography';
import { Stack } from '@fiverr-private/layout_components';
import { AppContext } from '../../../../context/listingsContext';
import { AppI18n } from '../../../../../../../shared/utils/i18n';
import SwitchContainer from '../../../SwitchContainer';
import { isBudgetActive } from '../../../util';
import type { ActiveFilters } from '../../../../business_listings/BusinessPageLayout/Types';

interface HourlyToggleProps {
    id?: string;
    alias?: string;
    value?: string;
    onChange?: () => boolean;
    filterValues?: ActiveFilters;
}

export const HourlyToggle = ({ value, id, alias, onChange = () => true, filterValues = {} }: HourlyToggleProps) => {
    const { inHourlyToggleExperiment } = useContext(AppContext);
    const disabled = inHourlyToggleExperiment && isBudgetActive(filterValues);

    return (
        <Stack direction="column" gap="0">
            <Stack direction="row" alignItems="center" justifyContent="spaceBetween">
                <Typography as="h5" paddingY="1" color={disabled ? 'grey_800' : 'inherit'}>
                    {alias}
                </Typography>
                <SwitchContainer value={value} id={id} onChange={onChange} disabled={disabled} />
            </Stack>

            {disabled && (
                <Text size="b_sm" color="bodySecondary" paddingTop="0">
                    <AppI18n k="search_perseus.filters.global.hourly_toggle.disabled_by_budget" />
                </Text>
            )}
        </Stack>
    );
};
